var React = require('react');

function CircleUnfilled8x8 (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4","cy":"4","r":"3","stroke":"currentColor","strokeWidth":"2"}));
}

CircleUnfilled8x8.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = CircleUnfilled8x8;

CircleUnfilled8x8.default = CircleUnfilled8x8;
